export const LOGIN_API = "user/login";

export const USERS = "user";

export const ROLES = 'role';

export const USER_CATEGORY = 'user_category';

export const CREATE_USER = 'user/create';

export const STATES = 'state';

export const DISTRICTS = 'district';

export const BLOCKS = 'block';

export const GRAM_PANCHAYAT = 'gram_panchayat';

export const CATEGORY = 'category'

export const DEPARTMENT = 'department'

export const SCHEME = 'scheme'

export const APPLICATION = 'application'

export const DASHBOARD = 'get_dashboard_data'

export const LAST_APPLICATION = 'get_last_applications'

export const CATEGORY_REPORT = 'report/category'

export const DISTRICT_REPORT = 'report/district'

export const DEPARTMENT_REPORT = 'report/department'

export const SCHEMA_REPORT = 'report/schema'

export const BLOCK_REPORT = 'report/block'

export const GRAMPANCHAYAT_REPORT = 'report/gram_panchayat'

export const CAMPAIGN = 'camp'

export const CHANGE_SCHEME_STATUS = 'change_scheme_status'

export const LAST_CAMP_DATA = 'get_last_camp_data'

export const APPLICATIONS_BY_DATE = 'get_applications_by_date'
